import { formatTooltipFilterDateRange, getTooltipPeriodReferenceYear } from '@web/utility/ tooltip/periodComparisonTooltip';
import { getPreviousPeriod } from '@workalizer/shared/utils';
export var buildGeminiFilterPeriodTooltipLabels = function (dateFrom, dateTo) {
    var referenceYear = getTooltipPeriodReferenceYear(dateFrom, dateTo);
    var _a = getPreviousPeriod(dateFrom, dateTo), prevPeriodDateFrom = _a.prevPeriodDateFrom, prevPeriodDateTo = _a.prevPeriodDateTo;
    return {
        currentPeriodComparisonLabel: formatTooltipFilterDateRange(dateFrom, dateTo, referenceYear),
        previousPeriodLabel: formatTooltipFilterDateRange(prevPeriodDateFrom, prevPeriodDateTo, referenceYear)
    };
};
export var buildGeminiWeekPeriodTooltipLabel = function (weekDateFrom, weekDateTo, dateFrom, dateTo) {
    return formatTooltipFilterDateRange(weekDateFrom, weekDateTo, getTooltipPeriodReferenceYear(dateFrom, dateTo));
};
